import ContentBody from '@op/components/ContentBody';
import React, { useMemo, useState } from 'react';
import { Card, Col, Copy, Layout, Row, TextArea } from 'tea-component';
const { Content } = Layout;
const height = 'calc(100vh - 200px)';
export default function FormatConfig() {
  const [text, setText] = useState('');
  const formatText = useMemo(() => {
    if (text === '') return '';
    try {
      const jsonStr = text
        .replace(/,\s*([}\]])/g, '$1')
        .replace(/(\w+):/g, '"$1":') // 属性名加引号
        .replace(/'/g, '"') // 单引号转双引号
        .replace(/\s+(?=([^"]*"[^"]*")*[^"]*$)/g, ''); // 移除所有空格
      return JSON.stringify(JSON.parse(jsonStr));
    } catch (error) {
      console.log(error);
      return '格式化失败';
    }
  }, [text]);

  return (
    <Content className="dbo-page dbo-performance">
      <ContentBody
        contentHeard={
          <Content.Header
            className="dbo-header"
            title={'配置数据格式化'}
          ></Content.Header>
        }
      >
        <Row>
          <Col span={12}>
            <TextArea
              showCount
              style={{ height }}
              size="full"
              value={text}
              onChange={(value) => {
                setText(value);
              }}
              placeholder="输入文本内容"
            />
          </Col>
          <Col span={12}>
            <Card>
              <Card.Body
                style={{ height, wordBreak: 'break-all' }}
                title="格式化后内容区"
                operation={<Copy text={formatText} />}
              >
                {formatText}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </ContentBody>
    </Content>
  );
}
